module.exports = __webpack_public_path__ + "media/images/mobile/abouts/m_jg-78b3eda5539f54707a0c05c98a751e2c.jpg";